module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/transform.js
// module id = 1262
// module chunks = 0